import type { ApiClient } from "../../../infrastructure/http/apiClient";
import { ApiClientError } from "../../../infrastructure/http/apiClient";
import type { AuthRefreshSession } from "../domain/session";

const AUTH_REFRESH_PATH = "/api/v1/auth/refresh";

export async function refreshSession(apiClient: ApiClient): Promise<AuthRefreshSession> {
  const response = await apiClient.post<unknown, Record<string, never>>(AUTH_REFRESH_PATH, {});

  if (!isAuthRefreshSession(response)) {
    throw new ApiClientError("The auth/refresh response did not match the expected contract.", {
      code: "invalid_response"
    });
  }

  return response;
}

function isAuthRefreshSession(value: unknown): value is AuthRefreshSession {
  return isRecord(value)
    && typeof value.access_token === "string";
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}
